import installationInstructions from './installationInstructions';

const p159Content = {
  installationInstructions
}

export { p159Content };
